import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SdHeadingComponent } from '@sdvor/seo/ui';
import {
  CustomCloseAccountComponent,
  CustomUpdatePasswordComponent,
  CustomUpdateProfileComponent,
} from '../../components';

@Component({
  selector: 'sd-update-profile-page',
  templateUrl: './update-profile-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CustomUpdateProfileComponent,
    SdHeadingComponent,
    CustomUpdatePasswordComponent,
    CustomCloseAccountComponent,
  ],
})
export class UpdateProfilePageComponent {}
